module.exports = __webpack_public_path__ + "static/media/07_Aladdin (ft Ikhana)_lowered for context_05-14.0c67d47c.mp3";